import React from 'react';
import { Text, Link, Subtitle1, Divider } from '@fluentui/react-components';

interface AskGroovSectionProps {
  privacyPolicyUrl?: string;
}

export const AskGroovSection: React.FC<AskGroovSectionProps> = ({ privacyPolicyUrl }) => {
  const askGroovText1 = `Ask Groov is your AI-powered wellbeing guide, built to help you navigate everyday challenges — at work and in life.`;
  const askGroovText2 = `It connects you with trusted, personalised support and practical guidance designed to fit into real moments, so you can take small steps that make a big difference.`;
  const askGroovText3 = `Just message Groov like you would a teammate — and get a thoughtful, science-backed answer in seconds.`;
  const askGroovText4 = `Try asking:`;
  const askGroovText5 =
    `• "How can I prepare for a tough conversation?"
    • "What’s one way to reset after a big day?"`;
  const askGroovText6 = `Ask Groov combines behavioural science, leadership expertise, and mental-health insight to help you take action in the moment.
  Your privacy is important to us.`;

  return (
    <>
      <Subtitle1 style={{ marginTop: 15 }}>Ask Groov</Subtitle1>
      <Text style={{ whiteSpace: 'pre-line' }}>
        {askGroovText1}
      </Text>
      <Text style={{ whiteSpace: 'pre-line' }}>
        {askGroovText2}
      </Text>
      <Text style={{ whiteSpace: 'pre-line' }}>
        {askGroovText3}
      </Text>
      <strong style={{ marginBottom: -10 }}>{askGroovText4}</strong>
      <Text style={{ whiteSpace: 'pre-line' }}>
        {askGroovText5}
      </Text>
      <Text style={{ whiteSpace: 'pre-line' }}>
        {askGroovText6}
        {privacyPolicyUrl ? (
          <>
            {' '}View our{' '}
            <Link href={privacyPolicyUrl} target="_blank" rel="noreferrer">
              Privacy Policy
            </Link>
            .
          </>
        ) : (
          ' View our Privacy Policy.'
        )}
      </Text>
      <br/>
      <Divider />
    </>
  );
};

